import React from 'react';
import { FiFilter } from 'react-icons/fi';
import { C, YEARS, MONTHS } from './tokens';

export function MisPeriodBar({ year, setYear, month, setMonth, onLoad, loading, extra }) {
  const sel = { height:36, border:`1px solid ${C.border}`, borderRadius:8, padding:'0 10px',
    fontSize:13, color:C.t1, background:C.white, outline:'none', fontFamily:'inherit' };
  return (
    <div style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`,
      padding:'14px 18px', marginBottom:14, boxShadow:'0 2px 6px rgba(13,59,94,0.06)' }}>
      <div style={{ fontSize:11, fontWeight:700, color:C.t4, textTransform:'uppercase',
        letterSpacing:'0.08em', marginBottom:12 }}>Select Period</div>
      <div style={{ display:'flex', gap:10, alignItems:'flex-end', flexWrap:'wrap' }}>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:C.t2, display:'block', marginBottom:5 }}>Year</label>
          <select value={year} onChange={e => setYear(e.target.value)} style={{ ...sel, minWidth:100 }}>
            {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize:12, fontWeight:600, color:C.t2, display:'block', marginBottom:5 }}>Month</label>
          <select value={month} onChange={e => setMonth(e.target.value)} style={{ ...sel, minWidth:140 }}>
            {MONTHS.map(m => <option key={m.v} value={m.v}>{m.l}</option>)}
          </select>
        </div>
        {extra}
        <button onClick={onLoad} disabled={loading}
          style={{ height:36, padding:'0 20px', borderRadius:8, background:loading ? C.navyM : C.navy,
            color:'#fff', border:'none', fontSize:13, fontWeight:700,
            cursor:loading ? 'not-allowed' : 'pointer', fontFamily:'inherit',
            display:'flex', alignItems:'center', gap:6, opacity:loading ? 0.75 : 1 }}>
          {loading
            ? <><div style={{ width:11, height:11, borderRadius:'50%', border:'2px solid rgba(255,255,255,0.35)', borderTopColor:'#fff', animation:'spin 0.8s linear infinite' }}/> Loading…</>
            : <><FiFilter size={12}/> Load Report</>}
        </button>
      </div>
    </div>
  );
}

export function MisNotSearched({ label, icon }) {
  return (
    <div style={{ background:C.white, borderRadius:12, border:`1px solid ${C.border}`,
      padding:'52px 24px', textAlign:'center', boxShadow:'0 2px 6px rgba(13,59,94,0.06)' }}>
      <div style={{ width:54, height:54, borderRadius:'50%', background:C.navyL,
        display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
        {icon}
      </div>
      <div style={{ fontSize:14, fontWeight:700, color:C.t1, marginBottom:6 }}>{label}</div>
      <div style={{ fontSize:12.5, color:C.t3 }}>Choose year and month, then click "Load Report"</div>
    </div>
  );
}

export function monthLabel(year, month) {
  try {
    return new Date(`${year}-${String(month).padStart(2, '0')}-01`)
      .toLocaleString('en-IN', { month: 'long', year: 'numeric' });
  } catch { return `${month}/${year}`; }
}
